import { useMemo, useState } from 'react'
import { UIChatItem } from '../../../types'

type Props = {
  item: UIChatItem
  onSend: (item: UIChatItem) => Promise<void>
}

export const useLogic = ({ item, onSend }: Props) => {
  const [isSent, setSent] = useState(false)
  const [content, setContent] = useState(item?.content)

  const send = async () => {
    const itemUpdated = { ...item, content }
    setSent(true)
    await onSend(itemUpdated)
  }

  const itemBuilt = useMemo((): UIChatItem => {
    if (isSent) {
      return { ...item, content, status: 'SENT' }
    } else {
      return item
    }
  }, [isSent])

  return {
    content,
    onChangeContent: setContent,
    send,
    item: itemBuilt,
  }
}
